import { firebaseAuth } from "utils/firebase/initializeFirebase";
import { signOut } from "firebase/auth";

export default async function firebaseLogout(): Promise<void> {
  await signOut(firebaseAuth);
}
